module.exports = __webpack_public_path__ + "static/media/pochette 3-3.71fc4f45.jpg";